module.exports = __webpack_public_path__ + "static/img/WMP869_A.6854ec9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WMP869_A.jpg
// module id = Xrwc
// module chunks = 0